import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { StorageHelper } from '@app/_helpers';
import { Observable } from 'rxjs';
import { AuthService, AuthRole } from '../../../modules/auth';

@Injectable({
    providedIn: 'root'
})
export class DashboardGuard  {

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.isValid();
    }
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this.isValid();
    }


    /**
     * Only Allow opening dashboard if user is authenticated.
     * Else redirect to login page/ Mpin Page.
     *
     * @returns true if user is authenticated.
     */
    isValid() {
        if (!this.authService.isAuthenticated) {
            this.router.navigate(['/auth']);
            return false;
        } else if (this.authService.isAuthenticated && this.authService.accessTokenObj.isExpired && this.authService.refreshTokenObj.isExpired) {
            this.authService.clearLogout()
            return false;
        } else if (this.authService.accessTokenObj.role === AuthRole.ADMIN) {
            this.authService.adminLoginOperator(this.authService.userInfo.access);
            this.router.navigate(['/admin']);
            return false;
        } else if (this.authService.accessTokenObj.role === AuthRole.BUSINESSPARTNER || this.authService.accessTokenObj.role === AuthRole.SUPERDEALER) {
            this.router.navigate(['/affiliate']);
            return false;
        }
        // If access token is expired, it will be refreshed by the interceptor automatically
        // Refresh token has infinite expiry, so no need to check it
        return true;
    }
}
